import { createContext } from 'react';
const TransportContext = createContext(null);
const TransporProvider = TransportContext.Provider;
export { TransportContext, TransporProvider };
//# sourceMappingURL=transport-provider.js.map